<div class="message-files" *ngIf="message != null">
    <header [hidden]="(message.attachments ?? message.files).length == 0">
        <h4 *ngIf="show" (click)="toggleAttachments()"><em>{{(message.attachments ?? message.files).length}}</em> <span class="arrow-up">Attachment{{(message.attachments ?? message.files).length > 1 ? 's':''}}</span></h4>
        <h4 *ngIf="!show" (click)="toggleAttachments()"><em>{{(message.attachments ?? message.files).length}}</em> <span class="arrow-down">Attachment{{(message.attachments ?? message.files).length > 1 ? 's':''}}</span></h4>
      </header>
    <div [hidden]="!show">
        <ng-container *ngIf="message.attachments; else regularfiles">
            <core-signed-files-list 
                [files]="message.attachments" 
                [notes]="notesCounter" 
                [menu]="menu" 
                [context]="context"
                (menuClick)="onMenuClick($event)" 
                (actionClick)="openNotes($event)"
                (iconDownloadClick)="onActionDownloadClick($event)"
                (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()">
            </core-signed-files-list>
        </ng-container>
        <ng-template #regularfiles>
            <core-files-list-notes *ngIf="notesCounter != null"
                [files]="message.files"
                [notes]="notesCounter" 
                [menu]="menu" 
                [context]="context" 
                (menuClick)="onMenuClick($event)"
                (actionClick)="openNotes($event)" 
                (iconDownloadClick)="onActionDownloadClick($event)">
            </core-files-list-notes>
        </ng-template>
            
        
        <!-- alternative way because pdf web viewer can't be initialized several times in same component when selectedFile changes-->
        <div  *ngIf="(message.attachments ?? message.files).length > 0" >
            <div *ngFor="let file of (message.attachments ?? message.files)">
                <core-pdf-annotations-viewer  *ngIf="selectedFile != null && selectedFile.id == file.id"
                    [file]="selectedFile" 
                    [annotationsAllowed]="canCreateNotes" 
                    [urlAnnotationsPrefix]="'/messages/'+message.id"
                    [user]="user"
                    [context]="context"
                    (saved)="notesSaved($event)"
                    (refreshSignaturesNeeded)="onRefreshSignaturesNeeded($event)"
                    >
                </core-pdf-annotations-viewer>
            </div>
        </div>
    </div>
</div>
